import angular from 'angular';
import expandableTable from './expandableTable';
import './style.scss';

export default angular
  .module('contactLending.components.expandableTable', [])
  .component('expandableTable', expandableTable).name;
